import { styled } from "styled-components";

export const StyledSVG = styled.svg`
  cursor: pointer;
`;
